import React, { useRef, useEffect, useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faComment,
  faVideo,
  faEyeSlash,
  faVideoSlash,
  faMicrophone,
  faMicrophoneSlash,
  faEnvelope,
  faLink,
} from "@fortawesome/free-solid-svg-icons";
import { faDotCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faLinkedin,
  faTwitterSquare,
} from "@fortawesome/free-brands-svg-icons";
import _ from "lodash";
import { connect } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import firebase from "firebase";
import { useCollection, useDocument } from "react-firebase-hooks/firestore";
import { Badge, Button, Spinner, Modal, Form } from "react-bootstrap";
import Webcam from "react-webcam";
import Avatar from "react-avatar";
import parse from "html-react-parser";

import LeftBar from "./LeftBar";
import NavBar from "./NavBar";
import EventChat from "./EventChat";
import Video from "./Video";

import { changeLanguage, setCurrentUser } from "../../../store/actions/actions";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Styles.css";
import { sendEmail } from "../../../utils";
toast.configure();

function Event({
  currentLanguage,
  changeLanguage,
  darkTheme,
  setCurrentUser,
  currentUser,
}) {
  const { hash, pathname } = useLocation();
  const history = useHistory();
  const { id, category_id } = useParams();
  const [currentEvent, setCurrentEvent] = useState({});
  const current_user = firebase.auth().currentUser;
  const [showChat, setShowChat] = useState(false);
  const [openMeeting, setOpenMeeting] = useState(false);
  const [videoMute, setVideoMute] = useState(false);
  const [audioMute, setAudioMute] = useState(false);
  const [isLive, setIsLive] = useState(false);
  const [currentProfile, setCurrentProfile] = useState(null);
  const [showNM, setShowNM] = useState(false);
  const [show, setShow] = useState(false);
  const [networkingMessage, setNetworkingMessage] = useState(
    `I'd like to join your network. `
  );
  const [networkingMessageErr, setNetworkingMessageErr] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleShowNM = () => setShowNM(true);
  const handleCloseNM = () => {
    setShowNM(false);
    setNetworkingMessage(`I'd like to join your network.`);
  };
  const openProfile = (attendee) => {
    setCurrentProfile(attendee);
    handleShow();
  };

  const pageRef = useRef(null);
  useEffect(() => {
    pageRef && pageRef.current.scrollIntoView();
  }, []);

  const [myDoc, loadingMyDoc, errorMyDoc] = useDocument(
    current_user &&
      firebase.firestore().collection("users").doc(current_user.uid)
  );

  const [eventSnapshot, loadingEvent, errorEvent] = useCollection(
    firebase
      .firestore()
      .collection("events")
      .where("isDemo", "==", true)
      .where("slug", "==", `${id}`)
  );

  useEffect(() => {
    if (eventSnapshot) {
      setCurrentEvent({
        ...eventSnapshot?.docs[0]?.data(),
        id: eventSnapshot?.docs[0]?.id,
      });
    }
  }, [eventSnapshot, loadingEvent]);

  useEffect(async () => {
    if (current_user && !loadingEvent && currentEvent?.id != null) {
      const querySnapshot = await firebase
        .firestore()
        .collection(`/events/${currentEvent?.id}/users`)
        .where("email", "==", current_user.email)
        .get();

      if (querySnapshot?.empty) {
        toast.info(
          `Hello ${current_user.email}, looks like you are not registered for this event`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          }
        );
        history.push("./complete-registration");
      }
      if (querySnapshot?.docs?.length > 0 && querySnapshot?.docs[0]?.data()) {
        setCurrentUser(querySnapshot?.docs[0]?.data());
        if (currentEvent.custom_form_required) {
          const { custom_form_filled } = querySnapshot?.docs[0]?.data();

          if (!custom_form_filled || custom_form_filled == null) {
            history.push("./fill-details");
          }
        }
      }
    }
  }, [current_user, currentEvent, loadingEvent]);

  const checkUserIsAdmin = () => {
    if (
      currentUser?.uid === currentEvent?.created_by ||
      currentEvent?.event_manager?.includes(currentUser?.email)
    ) {
      return true;
    }
    return false;
  };

  const categoryId = checkUserIsAdmin
    ? category_id
    : currentUser?.category === category_id
    ? category_id
    : currentUser?.category;

  const [
    attendeeCategorySnapshot,
    attendeeCategoryLoading,
    attendeeCategoryError,
  ] = useCollection(
    firebase
      .firestore()
      .collection(`events/${currentEvent?.id}/attendee_category`)
      .orderBy("timestamp", "asc")
  );

  const attendeeCategoryList = useMemo(() => {
    return attendeeCategorySnapshot?.docs?.map((e) => {
      return {
        ...e.data(),
        id: e.id,
      };
    });
  }, [attendeeCategorySnapshot]);

  const getAttendeeCategoryName = (id) => {
    return attendeeCategoryList?.find((item) => item.id === id)?.name;
  };

  const [attendeeListSnapshot, attendeeListLoading, attendeeListError] =
    useCollection(
      firebase
        .firestore()
        .collection(`events/${currentEvent?.id}/users`)
        .where("category", "==", categoryId)
    );

  const attendeeList = useMemo(() => {
    return attendeeListSnapshot?.docs?.map((e) => {
      return {
        ...e.data(),
        id: e.id,
      };
    });
  }, [attendeeListSnapshot]);

  useEffect(() => {
    firebase
      .firestore()
      .collection(`sessions/${currentEvent?.id?.toLowerCase()}/rooms`)
      .doc(`${categoryId?.toLowerCase()}`)
      .onSnapshot((doc) => {
        if (doc.exists) {
          if (doc?.data()?.currentSession != "") {
            setIsLive(true);
          }
        }
      });
  }, [currentEvent?.id, categoryId]);

  const UserAvatar = ({ imgSize, attendee }) => {
    const [userDoc, loadingDoc, errorDoc] = useDocument(
      attendee && firebase.firestore().collection("users").doc(attendee.uid)
    );

    let img_size = imgSize ? imgSize : 25;

    if (loadingDoc)
      return (
        <Avatar
          name={attendee.firstName + " " + attendee.lastName}
          round={true}
          size={img_size}
          textSizeRatio={1.75}
          className="mr-3"
          onClick={() => openProfile(attendee)}
          style={{ cursor: "pointer" }}
        />
      );

    if (!loadingDoc)
      return userDoc.data().avatar.indexOf("solo-icon.svg") > -1 ? (
        <Avatar
          name={attendee.firstName + " " + attendee.lastName}
          round={true}
          size={img_size}
          textSizeRatio={1.75}
          className="mr-3"
          onClick={() => openProfile(attendee)}
          style={{ cursor: "pointer" }}
        />
      ) : (
        <img
          title={attendee.firstName + " " + attendee.lastName}
          src={userDoc.data().avatar}
          className="img-fluid rounded-circle mr-3"
          style={{ height: img_size, width: img_size, cursor: "pointer" }}
          onClick={() => openProfile(attendee)}
        />
      );
  };

  const submitNetworkingRequest = async (e) => {
    e.preventDefault();

    if (currentProfile === null) {
      alert("Oops");
    }

    if (networkingMessage === "" || networkingMessage === null) {
      return;
    }

    try {
      await sendEmail({
        to: currentProfile.email,
        subject: `Start a conversation with ${
          !loadingMyDoc && myDoc.data().displayName
        } - ${eventSnapshot?.docs[0]?.data()?.event_details[`EN`]?.event_name}`,
        content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src=${
          eventSnapshot?.docs[0]?.data()?.event_details?.featured_image
        } alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi ${
          currentProfile.firstName
        }, </span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">${networkingMessage}<br/><br/> 
        ${
          !loadingMyDoc && myDoc.data().displayName
            ? `${myDoc.data().displayName} <br/> `
            : ""
        }
        ${!loadingMyDoc && myDoc.data().bio ? `${myDoc.data().bio} <br/> ` : ""}
        ${
          !loadingMyDoc && myDoc.data().linkedinURL
            ? `${myDoc.data().linkedinURL} <br/> `
            : ""
        }
        ${
          !loadingMyDoc && myDoc.data().twitterURL
            ? `${myDoc.data().twitterURL} <br/> `
            : ""
        }
        ${
          !loadingMyDoc && myDoc.data().websiteURL
            ? `${myDoc.data().websiteURL} <br/> `
            : ""
        }
        <br/>Reply to this email to continue the conversation.</span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://platform.igesia.co/event/${
          eventSnapshot?.docs[0]?.data()?.slug
        }/dashboard/" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Visit Event Dashboard</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,

        from: `"${current_user.displayName} | Igesia" <noreply@igesia.co>`,
        replyTo: current_user.email,
      });
      toast.success("Networking request successfully sent", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
      handleCloseNM();
    } catch (e) {
      console.error(e, "error in sending Networking request");
    }
  };

  const getWhetherURLOrLocalFile = (file) => {
    if (!file.name) {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };

  const [userProfileDoc, userProfileLoading, userProfileError] = useDocument(
    currentProfile &&
      firebase.firestore().collection("users").doc(currentProfile.uid)
  );

  return (
    <div className="h-100" ref={pageRef}>
      <LeftBar mobile />
      <div className="container-fluid h-100" style={{ overflow: "hidden" }}>
        <NavBar />
        <div className="row" style={{ height: "93vh", overflow: "hidden" }}>
          <LeftBar />
          <div
            className="col-md-7 h-100 p-md-5 p-3"
            data-theme={darkTheme ? "dark" : "light"}
            style={{ overflow: "scroll" }}
          >
            <div className="px-0 pb-md-3 pb-5">
              <div className="mb-3">
                <p className="mb-1 text-uppercase small">
                  <b>Your Group</b>
                </p>
                <div
                  className={
                    darkTheme
                      ? "border border-dark rounded shadow-sm p-2"
                      : "border rounded shadow-sm p-2"
                  }
                >
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 d-flex align-items-start">
                      <div className="flex-grow-1">
                        <div className="d-flex align-items-start">
                          <h5 className="m-0 font-weight-bold">
                            {getAttendeeCategoryName(categoryId)}
                          </h5>
                          <div className="ml-2 small">
                            {isLive ? (
                              <Badge variant="danger">
                                <div className="d-flex align-items-center">
                                  <FontAwesomeIcon
                                    icon={faDotCircle}
                                    className="mr-1"
                                  />
                                  <span>Live</span>
                                </div>
                              </Badge>
                            ) : null}
                          </div>
                        </div>
                        <p className="small mb-0">
                          <b>*</b>To work on other tools simultaneously, open
                          the app in another tab.
                        </p>
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant={openMeeting ? "danger" : "primary"}
                      className="text-uppercase"
                      onClick={() => setOpenMeeting((prev) => !prev)}
                      disabled={currentEvent?.id == "" && categoryId == ""}
                    >
                      <FontAwesomeIcon icon={faVideo} className="mr-2" />
                      {openMeeting ? "End" : "Join"} Meeting
                    </Button>
                  </div>
                </div>
              </div>

              {!openMeeting && (
                <div
                  className={
                    darkTheme
                      ? "p-3 rounded-lg mb-3 shadow-sm border border-dark d-flex flex-column align-items-center justify-content-center"
                      : "p-3 rounded-lg mb-3 shadow-sm border d-flex flex-column align-items-center justify-content-center"
                  }
                  style={{ height: "400px" }}
                >
                  <h4 className="mb-3 text-center">
                    Select your video and audio preferences
                    <br /> before joining.
                  </h4>
                  <div
                    className="mb-3 pointer mx-auto"
                    style={{ position: "relative", width: "300px" }}
                    onClick={() => {
                      setVideoMute(!videoMute);
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "48%",
                        left: "48%",
                        zIndex: "1000",
                      }}
                    >
                      {videoMute ? (
                        <FontAwesomeIcon
                          icon={faEyeSlash}
                          size="lg"
                          style={{ opacity: "75%" }}
                        />
                      ) : null}
                    </div>
                    <Webcam
                      audio={false}
                      videoConstraints={{ width: 300, height: 160 }}
                      height={160}
                      width={300}
                      className="rounded"
                      style={
                        videoMute
                          ? { filter: "blur(12px)", transform: "scaleX(-1)" }
                          : { transform: "scaleX(-1)" }
                      }
                    />
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="text-center mr-5">
                      <button
                        className={
                          videoMute
                            ? "btn btn-light rounded-circle mb-1"
                            : "btn btn-success rounded-circle mb-1"
                        }
                        style={{ width: "45px", height: "45px" }}
                        onClick={() => {
                          setVideoMute(!videoMute);
                        }}
                      >
                        {videoMute ? (
                          <FontAwesomeIcon icon={faVideoSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faVideo} />
                        )}
                      </button>
                      <p className="small text-theme">
                        {videoMute ? <>Video Off</> : <>Video On</>}
                      </p>
                    </div>
                    <div className="text-center">
                      <button
                        className={
                          audioMute
                            ? "btn btn-light rounded-circle mb-1"
                            : "btn btn-success rounded-circle mb-1"
                        }
                        style={{ width: "45px", height: "45px" }}
                        onClick={() => {
                          setAudioMute(!audioMute);
                        }}
                      >
                        {audioMute ? (
                          <FontAwesomeIcon icon={faMicrophoneSlash} />
                        ) : (
                          <FontAwesomeIcon icon={faMicrophone} />
                        )}
                      </button>
                      <br />
                      <p className="small text-theme">
                        {audioMute ? <>Audio Off</> : <>Audio On</>}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {openMeeting && (
                <div>
                  <Video
                    categoryId={categoryId}
                    event_id={currentEvent?.id}
                    group_name={getAttendeeCategoryName(categoryId)}
                    audioMute={audioMute}
                    videoMute={videoMute}
                    setOpenMeeting={setOpenMeeting}
                    openMeeting={openMeeting}
                    isAdmin={false}
                  />
                </div>
              )}
            </div>
            <div>
              <p className="mb-1 text-uppercase small">
                <b>Group Members</b>{" "}
                {attendeeList && (
                  <span>
                    (
                    {attendeeList?.length > 1
                      ? `${attendeeList?.length} members`
                      : `${attendeeList?.length} member`}
                    )
                  </span>
                )}
              </p>
              {attendeeListLoading ? (
                <div className="d-flex align-items-center justify-content-center">
                  <p>
                    <Spinner animation="border" size="sm" /> Loading...
                  </p>
                </div>
              ) : (
                attendeeList?.map((attendee, key) => (
                  <div
                    data-theme={darkTheme ? "dark" : "light"}
                    className=" w-100 px-3 px-md-4 py-2 border"
                    key={key}
                  >
                    <div className="d-flex align-items-center">
                      <UserAvatar attendee={attendee} />
                      <div
                        className="flex-grow-1"
                        onClick={() => openProfile(attendee)}
                        style={{ cursor: "pointer" }}
                      >
                        <p className="text-s-11 mb-0 text-left text-capitalize">
                          {attendee.firstName + " " + attendee.lastName}{" "}
                          {attendee.uid === current_user.uid && (
                            <span className="text-lowercase">(me)</span>
                          )}
                        </p>
                      </div>
                      <div>
                        {attendee.uid === current_user.uid ? (
                          <></>
                        ) : (
                          <Button
                            variant="outline-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShowNM();
                              setCurrentProfile(attendee);
                            }}
                            className="btn-sm ml-auto"
                            title="Send networking request"
                          >
                            <FontAwesomeIcon
                              icon={faEnvelope}
                              className="mr-1"
                            />
                            <span>Message</span>
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <div
            className="col-md-4 h-100 px-0 d-none d-md-block"
            style={{ overflow: "scroll" }}
          >
            <EventChat
              event_id={currentEvent?.id}
              tabs={
                currentEvent?.people_enabled
                  ? [
                      {
                        name: `${getAttendeeCategoryName(categoryId)} Chat`,
                        type: "chat",
                        chatroute: `/events/${currentEvent?.id}/attendee_category/${categoryId}/messages/`,
                      },
                      {
                        name: "People",
                        type: "people",
                      },
                    ]
                  : [
                      {
                        name: `${getAttendeeCategoryName(categoryId)} Chat`,
                        type: "chat",
                        chatroute: `/events/${currentEvent?.id}/attendee_category/${categoryId}/messages/`,
                      },
                    ]
              }
            />
          </div>
        </div>
      </div>

      {/* Chat Mobile view */}
      {showChat && (
        <div
          className="shadow-lg border border-muted"
          style={{
            height: "55vh",
            position: "fixed",
            bottom: "17vh",
            left: 10,
          }}
        >
          <EventChat event_id={currentEvent?.id} />
        </div>
      )}
      <div
        style={{
          position: "fixed",
          height: 45,
          width: 45,
          bottom: "10.5vh",
          left: 5,
        }}
        className="bg-primary rounded-circle d-block d-md-none"
      >
        <a
          className="d-flex align-items-center justify-content-center"
          onClick={() => setShowChat((prev) => !prev)}
          style={{
            height: 45,
            width: 45,
          }}
        >
          <FontAwesomeIcon
            className="text-white"
            icon={showChat ? faTimes : faComment}
            style={{ fontSize: 20 }}
          />
        </a>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {!userProfileLoading && userProfileDoc?.data().firstName && (
              <h3 className="text-s-6 text-dark mb-0">
                <>
                  {userProfileDoc?.data().firstName}{" "}
                  <>
                    {userProfileDoc.data().lastName && (
                      <span>{userProfileDoc.data().lastName}</span>
                    )}
                  </>
                </>
              </h3>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!userProfileLoading && userProfileDoc && (
            <div className="card event-card border-0 h-100 p-4">
              <div className="d-flex flex-column align-items-center">
                {userProfileDoc.data().avatar && (
                  <div
                    style={{
                      background: `url(${getWhetherURLOrLocalFile(
                        userProfileDoc.data().avatar
                      )}) 0% 0% / cover no-repeat`,
                      height: "150px",
                      width: "150px",
                    }}
                    className="rounded-circle mx-5"
                  />
                )}
                {userProfileDoc.data().firstName && (
                  <h3 className="text-s-6 text-dark mt-3">
                    {userProfileDoc.data().firstName ? (
                      <>
                        {userProfileDoc.data().firstName}{" "}
                        <>
                          {userProfileDoc.data().lastName && (
                            <span>{userProfileDoc.data().lastName}</span>
                          )}
                        </>
                      </>
                    ) : (
                      "Your name"
                    )}
                  </h3>
                )}
                <p className="mb-3 text-dark">
                  {userProfileDoc.data().email
                    ? userProfileDoc.data().email
                    : null}
                </p>
                <div className="d-flex mb-2">
                  {userProfileDoc.data().linkedinURL ? (
                    <>
                      <a
                        className="mr-3"
                        rel="noreferrer noopener"
                        target="_blank"
                        href={userProfileDoc.data().linkedinURL}
                      >
                        <FontAwesomeIcon
                          icon={faLinkedin}
                          className="text-primary"
                          style={{ fontSize: 20 }}
                        />
                      </a>
                    </>
                  ) : null}

                  {userProfileDoc.data().twitterURL ? (
                    <>
                      <a
                        className="mr-3"
                        rel="noreferrer noopener"
                        target="_blank"
                        href={userProfileDoc.data().twitterURL}
                      >
                        <FontAwesomeIcon
                          icon={faTwitterSquare}
                          className="text-primary"
                          style={{ fontSize: 20 }}
                        />
                      </a>
                    </>
                  ) : null}

                  {userProfileDoc.data().videoMeetingLink ? (
                    <a
                      className="mr-3"
                      rel="noreferrer noopener"
                      target="_blank"
                      href={userProfileDoc.data().videoMeetingLink}
                    >
                      <FontAwesomeIcon
                        icon={faVideo}
                        className="text-primary"
                        style={{ fontSize: 20 }}
                      />
                    </a>
                  ) : null}

                  {userProfileDoc.data().websiteURL ? (
                    <a
                      rel="noreferrer noopener"
                      target="_blank"
                      href={userProfileDoc.data().websiteURL}
                    >
                      <FontAwesomeIcon
                        icon={faLink}
                        className="text-primary"
                        style={{ fontSize: 20 }}
                      />
                    </a>
                  ) : null}
                </div>
              </div>
              <div className="card-body h-100 p-0 bg-white">
                <p className="mb-3 text-dark text-center">
                  {userProfileDoc.data().bio
                    ? parse(userProfileDoc.data().bio)
                    : null}
                </p>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showNM}
        onHide={handleCloseNM}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className="d-flex align-items-center">
            <UserAvatar imgSize={36} attendee={currentProfile} />
            {/* <div
              className="border rounded-circle d-flex align-items-center justify-content-center mr-2"
              style={{ height: 30, width: 30 }}
            >
              <FontAwesomeIcon
                icon={faUserFriends}
                className="text-primary"
                style={{ fontSize: "16" }}
              />
            </div> */}
            {currentProfile ? (
              <div>
                <p className="h6 mb-0">{currentProfile.displayName}</p>
                <p className="small text-muted mb-0">Networking request</p>
              </div>
            ) : (
              <p className="h6 mb-0">Networking request</p>
            )}
          </div>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={submitNetworkingRequest}>
            {/* <Form.Group controlId="formBasicEmail">
              <Form.Label>Subject</Form.Label>
              <Form.Control 
                name="subject" 
                type="text" 
                placeholder="Enter subject" 
                value={subject}
                onChange={e => {
                  setSubject(e.target.value)
                  setSubjectErr(false)
                }}
               />
            </Form.Group>
            {subjectErr && <small className="text-danger">Please add a subject to understand the issue well</small>} */}

            <Form.Group
              className="mb-0"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Enter your message</Form.Label>
              <Form.Control
                name="networkingMessage"
                as="textarea"
                rows={4}
                onChange={(e) => {
                  setNetworkingMessage(e.target.value);
                  setNetworkingMessageErr(false);
                }}
                value={networkingMessage}
              />
            </Form.Group>
            {networkingMessageErr && (
              <small className="text-danger">
                <b>Error</b>: Please add some message
              </small>
            )}

            <Button variant="primary" type="submit" className="mt-3">
              Submit
            </Button>
          </Form>

          <div className="">
            <small>
              <b>Note:</b> Your name and email details will be sent with this
              message.
            </small>
            {/* <div>
              <p>{!loadingMyDoc && myDoc.data().bio}</p>
              <p>{!loadingMyDoc && myDoc.data().linkedinURL}</p>
              <p>{!loadingMyDoc && myDoc.data().twitterURL}</p>
              <p>{!loadingMyDoc && myDoc.data().websiteURL}</p>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    currentUser: state.currentUser,
    darkTheme: state.darkTheme,
  }),
  { changeLanguage, setCurrentUser }
)(Event);
